export default __webpack_public_path__ + "static/media/ossscreen9.85c07110.png";